<!-- ── PAGE ── -->
<div class="page">

  <!-- ── STAT CARDS ── -->
  <div class="stats-grid" [attr.data-count]="statCards.length">
    @for (data of statCards; track data.id) {
    <div class="custom-col" [class.few-items]="statCards.length > 5">
      <div class="card-anim-wrapper" [ngStyle]="{ 'animation-delay': (data.id * 100) + 'ms' }" class="card-animate"
        id="{{ data.key }}">
        <div class="card o-hidden small-widget"
          (click)="data?.key && (data.show ? switchChargeTab(data.key,true) : switchTab(data.key))"
          [ngbTooltip]="data.Positive_Name" [ngStyle]="{ cursor: data?.key ? 'pointer' : 'default' }">
          <div class="card-body {{ data.class1 }} {{ data.key }}">
            <h5 class="f-w-600 f-14 custom-div-prop">{{ data.title }}</h5>

            <div class="project-details">
              <div class="project-counter">
                <h3 class="f-w-600 z-1" [ngbTooltip]="data.total.toLocaleString('en-IN')" placement="bottom">
                  {{ data.total }}
                </h3>
              </div>
              <div class="product-sub bg-{{ data.class2 }}-light" [class.few-items]="statCards.length > 5">
                <img class="img-20" src="{{ data.imagepath }}" />
              </div>
            </div>

            <ul class="bubbles">
              <li class="bubble"></li>
              <li class="bubble"></li>
              <li class="bubble"></li>
              <li class="bubble"></li>
              <li class="bubble"></li>
              <li class="bubble"></li>
              <li class="bubble"></li>
              <li class="bubble"></li>
              <li class="bubble"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  <!-- SITELIST -->
  <!-- SITE + LOCATION LIST ACCORDION -->
  <div class="site-location-card" #SiteList>
    <!-- Header -->
    <div class="slc-head" (click)="toggleSiteListAccordion()" [attr.aria-expanded]="isSiteListOpen">
      <span class="slc-dot"></span>
      <span class="slc-title">Site & Location Details</span>
      <span class="slc-count" *ngIf="mergedData.length > 0">{{ mergedData.length }} records</span>
      <svg class="slc-chevron" [class.open]="isSiteListOpen" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5">
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </div>

    <div class="slc-body" [class.open]="isSiteListOpen">

      <!-- Action Controls -->
      <div class="slc-actions"
        style="display: flex; justify-content: flex-end; gap: 10px; margin-bottom: 10px; margin-right: 15px; margin-top: 15px;"
        *ngIf="originalSiteListData.length > 0">
        <input type="text" class="form-control"
          style="width: 200px; display: inline-block; padding: 5px 10px; border: 1px solid #ced4da; border-radius: 4px;"
          placeholder="Search Site..." [(ngModel)]="siteSearchTerm" (input)="applySiteListFilter()" />
        <button class="btn btn-primary"
          style="padding: 5px 15px; border-radius: 4px; border: 1px solid #255991; background-color: #fff; color: #f1f4f7; font-weight: 500; cursor: pointer;"
          (click)="exportSiteListCSV()">
          Export CSV
        </button>
      </div>

      <!-- ── SHIMMER: shown while data is loading ── -->
      <ng-container *ngIf="originalSiteListData.length === 0 && isSiteListOpen">
        <div class="slc-shimmer-wrap">
          <!-- Fake header -->
          <div class="slc-shimmer-header">
            <div class="shimmer-cell shimmer-anim" *ngFor="let i of [1,2,3,4,5,6,7,8]"></div>
          </div>
          <!-- Fake rows -->
          <div class="slc-shimmer-row" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
            <div class="shimmer-cell shimmer-anim" *ngFor="let j of [1,2,3,4,5,6,7,8]"></div>
          </div>
        </div>
      </ng-container>

      <!-- ── NO RESULTS ── -->
      <div *ngIf="originalSiteListData.length > 0 && mergedData.length === 0"
        style="padding: 20px; text-align: center; color: #6c757d;">
        No results match your search.
      </div>

      <!-- ── REAL TABLE ── -->
      <ng-container *ngIf="mergedData.length > 0">
        <div class="slc-table-wrap">
          <table class="slc-table">
            <thead>
              <tr>
                <th *ngFor="let header of displayHeaders">
                  {{ header.key === 'mobile_no' ? 'User Mobile No' : header.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of paginatedSiteListRows">
                <td *ngFor="let header of displayHeaders">
                  {{ getValue(row, header.key) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="slc-pagination">
          <div class="slc-pagination-meta">
            <span class="slc-row-count">
              {{ (siteListCurrentPage - 1) * siteListPageSize + 1 }}–{{ getSiteListRangeEnd() }}
              of {{ mergedData.length }} records
            </span>
            <span class="slc-page-size-label">Rows per page</span>
            <select class="slc-page-size-select"
              style="padding: 2px 5px; border-radius: 4px; border: 1px solid #ced4da;" [ngModel]="siteListPageSize"
              (ngModelChange)="setSiteListPageSize($event)">
              <option *ngFor="let opt of siteListPageSizeOptions" [value]="opt">{{ opt }}</option>
            </select>
          </div>

          <div class="slc-pagination-nav">
            <button class="slc-pg-btn slc-pg-arrow" [disabled]="siteListCurrentPage === 1" (click)="goToSiteListPage(1)"
              title="First Page">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <polyline points="15 18 9 12 15 6" />
                <line x1="5" y1="18" x2="5" y2="6" />
              </svg>
            </button>
            <button class="slc-pg-btn slc-pg-arrow" [disabled]="siteListCurrentPage === 1"
              (click)="goToSiteListPage(siteListCurrentPage - 1)">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>

            <ng-container *ngFor="let p of siteListPageNumbers">
              <span class="slc-pg-ellipsis" *ngIf="p === -1">…</span>
              <button class="slc-pg-btn" *ngIf="p !== -1" [class.active]="p === siteListCurrentPage"
                (click)="goToSiteListPage(p)">{{ p }}</button>
            </ng-container>

            <button class="slc-pg-btn slc-pg-arrow" [disabled]="siteListCurrentPage === siteListTotalPages"
              (click)="goToSiteListPage(siteListCurrentPage + 1)">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
            <button class="slc-pg-btn slc-pg-arrow" [disabled]="siteListCurrentPage === siteListTotalPages"
              (click)="goToSiteListPage(siteListTotalPages)" title="Last Page">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <polyline points="9 18 15 12 9 6" />
                <line x1="19" y1="18" x2="19" y2="6" />
              </svg>
            </button>
          </div>
        </div>
      </ng-container>

    </div>
  </div>

  <!-- ── ALERT STRIP: meters where meterStatus=Y or dicStatus=Y ── -->
  <div class="alert-strip" *ngIf="stalertRows.length > 0" #AlertList>
    <div class="alert-strip-head" (click)="toggleAccordion()" [attr.aria-expanded]="isOpen">
      <span class="alert-dot"></span>
      <span class="alert-title">Meters with flagged status</span>
      <span class="alert-count">{{ stalertRows.length }} flagged</span>
      <svg class="alert-chevron" [class.open]="isOpen" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5">
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </div>

    <div class="alert-items" [class.open]="isOpen">

      <!-- Tabs -->
      <div class="alert-tabs">
        <button class="alert-tab" [class.active]="activeTab === 'meter'"
          (click)="switchTab('meter'); $event.stopPropagation()">
          <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          Meter Stale
          <span class="tab-count">{{ meterStaleRows.length }}</span>
        </button>
        <button class="alert-tab" [class.active]="activeTab === 'dic'"
          (click)="switchTab('dic'); $event.stopPropagation()">
          <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <path d="M8 21h8M12 17v4" />
          </svg>
          CB Stale
          <span class="tab-count">{{ dicStaleRows.length }}</span>
        </button>
      </div>

      <!-- Meter Stale Tab -->
      <div *ngIf="activeTab === 'meter'" class="alert-grid-wrap">
        <div class="alert-col-headers alert-col-headers--meter">
          <span>Site</span>
          <span>Location</span>
          <span>Serial No.</span>
          <span>CB</span>
          <span>Last Reading Time</span>
          <span>Status</span>
        </div>
        <div class="alert-grid-row alert-grid-row--meter" *ngFor="let r of meterStaleRows">
          <span class="a-site">{{ r.site.name }}</span>
          <span class="a-loc">{{ r.meter.locationNo }}</span>
          <span class="a-serial">{{ r.meter.meterSerialNo }}</span>
          <span class="a-dic">{{ r.meter.dicName }}</span>
          <span class="a-dic">{{ r.meter.readingReceived }}</span>
          <span class="a-status-chip a-status-meter">
            <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            Meter Stale
          </span>
        </div>
        <div class="alert-empty" *ngIf="meterStaleRows.length === 0">No meter stale entries.</div>
      </div>

      <!-- DIC Stale Tab -->
      <div *ngIf="activeTab === 'dic'" class="alert-grid-wrap">
        <div class="alert-col-headers alert-col-headers--dic">
          <span>Site</span>
          <span>Location</span>
          <span>Serial No.</span>
          <span>CB Name</span>
          <span>Last Reading Time</span>
          <span>Status</span>
        </div>
        <div class="alert-grid-row alert-grid-row--dic" *ngFor="let r of dicStaleRows">
          <span class="a-site">{{ r.site.name }}</span>
          <span class="a-loc">{{ r.meter.locationNo }}</span>
          <span class="a-serial">{{ r.meter.meterSerialNo }}</span>
          <span class="a-dic-name">{{ r.meter.dicName }}</span>
          <span class="a-dic-name">{{ r.meter.dicReadingReceived }}</span>
          <span class="a-status-chip a-status-dic">
            <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <rect x="2" y="3" width="20" height="14" rx="2" />
              <path d="M8 21h8M12 17v4" />
            </svg>
            CB Stale
          </span>
        </div>
        <div class="alert-empty" *ngIf="dicStaleRows.length === 0">No CB stale entries.</div>
      </div>

    </div>
  </div>
  <!-- ── CHARGING STATUS BLOCK ── -->
  <!-- Place this after the stats-grid and before (or after) the alert-strip -->

  <div class="charging-section" #ChargingSection>
    <div class="charging-section-header">
      <div class="charging-section-title">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
        </svg>
        Charging Status
      </div>
      <div class="charging-summary">
        <span class="cs-pill cs-pill-on">
          <span class="cs-blink"></span>
          {{ chargingMeters.length }} Charging
        </span>
        <span class="cs-pill cs-pill-off">
          {{ cutMeters.length }} Not Charging
        </span>
      </div>
    </div>

    <!-- Tabs + Search bar -->
    <div class="charging-controls">
      <div class="charging-tabs">
        <button class="charging-tab" [class.active]="activeChargeTab === 'all'" (click)="switchChargeTab('all')">
          All
          <span class="tab-count">{{ chargingStatusList.length }}</span>
        </button>
        <button class="charging-tab" [class.active]="activeChargeTab === 'charging'"
          (click)="switchChargeTab('charging')">
          <span class="cs-blink cs-blink--sm"></span>
          Charging
          <span class="tab-count tab-count--green">{{ chargingMeters.length }}</span>
        </button>
        <button class="charging-tab" [class.active]="activeChargeTab === 'cut'" (click)="switchChargeTab('cut')">
          Not Charging
          <span class="tab-count">{{ cutMeters.length }}</span>
        </button>
        <button class="charging-tab" [class.active]="activeChargeTab === 'long-charging'"
          (click)="switchChargeTab('long-charging')">
          Long charging
          <span class="tab-count">{{ longchargingMeters.length }}</span>
        </button>
      </div>

      <div class="charging-search-wrap">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input class="charging-search" type="text" placeholder="Search unit, meter no…" [(ngModel)]="chargeSearchQuery"
          (input)="onChargeSearch()" />
        <button class="charging-search-clear" *ngIf="chargeSearchQuery" (click)="clearChargeSearch()">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Empty state -->
    <div class="charging-empty" *ngIf="filteredChargingList.length === 0">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      No results for "{{ chargeSearchQuery }}"
    </div>

    <div class="charging-grid" *ngIf="filteredChargingList.length > 0">
      <div class="charging-card" *ngFor="let item of filteredChargingList" [class.is-charging]="item.isCharging"
        [class.is-cut]="!item.isCharging" (click)="onCardClick(item)">

        <!-- Car SVG Illustration -->
        <div class="car-illustration">
          <svg *ngIf="!item.isCharging" class="car-svg car-svg--idle" viewBox="0 0 120 60" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="28" width="100" height="22" rx="5" fill="#cbd5e1" />
            <path d="M30 28 L40 12 L80 12 L92 28 Z" fill="#94a3b8" />
            <path d="M43 14 L38 26 L56 26 L56 14 Z" fill="#e2e8f0" rx="2" />
            <path d="M58 14 L58 26 L78 26 L74 14 Z" fill="#e2e8f0" rx="2" />
            <circle cx="32" cy="50" r="9" fill="#64748b" />
            <circle cx="32" cy="50" r="4" fill="#94a3b8" />
            <circle cx="88" cy="50" r="9" fill="#64748b" />
            <circle cx="88" cy="50" r="4" fill="#94a3b8" />
            <rect x="106" y="32" width="5" height="8" rx="2" fill="#e2e8f0" />
            <rect x="10" y="32" width="5" height="8" rx="2" fill="#e2e8f0" />
            <circle cx="60" cy="20" r="7" fill="#f1f5f9" stroke="#94a3b8" stroke-width="1.5" />
            <line x1="57" y1="17" x2="57" y2="23" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round" />
            <line x1="63" y1="17" x2="63" y2="23" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round" />
            <line x1="57" y1="20" x2="63" y2="20" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round" />
          </svg>

          <svg *ngIf="item.isCharging" class="car-svg car-svg--charging" viewBox="0 0 120 60" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="60" cy="52" rx="48" ry="5" fill="#22c55e" opacity="0.15" />
            <rect x="10" y="28" width="100" height="22" rx="5" fill="#166534" />
            <path d="M30 28 L40 12 L80 12 L92 28 Z" fill="#15803d" />
            <path d="M43 14 L38 26 L56 26 L56 14 Z" fill="#bbf7d0" rx="2" />
            <path d="M58 14 L58 26 L78 26 L74 14 Z" fill="#bbf7d0" rx="2" />
            <circle cx="32" cy="50" r="9" fill="#14532d" />
            <circle cx="32" cy="50" r="4" fill="#22c55e" />
            <circle cx="88" cy="50" r="9" fill="#14532d" />
            <circle cx="88" cy="50" r="4" fill="#22c55e" />
            <rect x="106" y="32" width="5" height="8" rx="2" fill="#fef08a" />
            <rect x="10" y="32" width="5" height="8" rx="2" fill="#fde68a" />
            <circle cx="60" cy="20" r="7" fill="#dcfce7" stroke="#22c55e" stroke-width="1.5" />
            <polygon points="62,14 58,20 61,20 59,26 63,20 60,20" fill="#16a34a" />
          </svg>

          <div class="charge-bolts" *ngIf="item.isCharging">
            <svg class="bolt bolt-1" viewBox="0 0 12 20" fill="none">
              <polygon points="8,0 2,10 6,10 4,20 10,10 6,10" fill="#facc15" />
            </svg>
            <svg class="bolt bolt-2" viewBox="0 0 12 20" fill="none">
              <polygon points="8,0 2,10 6,10 4,20 10,10 6,10" fill="#22c55e" />
            </svg>
            <svg class="bolt bolt-3" viewBox="0 0 12 20" fill="none">
              <polygon points="8,0 2,10 6,10 4,20 10,10 6,10" fill="#facc15" />
            </svg>
          </div>

          <div class="charge-bar-wrap" *ngIf="item.isCharging">
            <div class="charge-bar-track">
              <div class="charge-bar-fill"></div>
            </div>
            <span class="charge-bar-label">Charging…</span>
          </div>
        </div>

        <div class="cc-info">
          <div class="cc-location">{{ item.locationNo }}</div>
          <div class="cc-location">{{ item.mobile_no }}</div>
          <div class="cc-meter">{{ item.meterSerialNo }}</div>
          <div class="cc-state" [class.cc-state-on]="item.isCharging" [class.cc-state-off]="!item.isCharging">
            <span class="cc-state-dot"></span>
            {{ item.isCharging ? 'Charging' : 'Not Charging' }}
          </div>
          <div class="cc-duration" *ngIf="item.isCharging">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            {{ item.durationLabel }}
          </div>
          <div class="cc-cut-time" *ngIf="!item.isCharging">
            Cut: {{ item.lastPowerCutTime }}
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- ── TABLE SECTION ── -->
  <div class="table-section" #targetSection>

    <!-- Table header row -->
    <div class="table-header-row">
      <div class="section-title">Meter-wise reading details</div>

      <div class="table-actions">
        <button class="action-btn filter-btn" [class.active]="showFilterBar" (click)="toggleFilterBar()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
          </svg>
          Filter
          <span class="filter-count-badge" *ngIf="activeFilter !== 'all'">1</span>
        </button>

        <button class="action-btn export-btn" (click)="exportCSV()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Export CSV
        </button>
      </div>
    </div>

    <!-- Filter bar -->
    <div class="filter-bar" *ngIf="showFilterBar">
      <span class="filter-label">Show:</span>

      <button class="fc-btn" [class.active]="activeFilter === 'all'" (click)="setFilter('all')">
        All meters
      </button>
      <button class="fc-btn fc-normal" [class.active]="activeFilter === 'normal'" (click)="setFilter('normal')">
        <span class="fc-dot fc-dot-fresh"></span> Normal
      </button>
      <button class="fc-btn fc-meter-flag" [class.active]="activeFilter === 'meter_flagged'"
        (click)="setFilter('meter_flagged')">
        <span class="fc-dot fc-dot-crit"></span> Stale Meter
      </button>
      <button class="fc-btn fc-dic-flag" [class.active]="activeFilter === 'dic_flagged'"
        (click)="setFilter('dic_flagged')">
        <span class="fc-dot fc-dot-dic"></span> Stale CB
      </button>
      <button class="fc-btn fc-dic-flag" (click)="reset()">
        Reset
      </button>
      <div class="charging-search-wrap">
        <input type="text" class="charging-search" placeholder="Search site / meter..." [(ngModel)]="searchTerm"
          (input)="applyTableFilters()" />
      </div>
    </div>

    <!-- No results -->
    <div class="no-results" *ngIf="filteredRows.length === 0">
      No meters match the selected filter.
    </div>

    <!-- Table -->
    <div class="table-wrap" *ngIf="filteredRows.length > 0">
      <table>
        <thead>
          <tr>
            <th *ngFor="let h of allTableHeaders">{{ h.name }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of paginatedRows; let i = index">
            <tr class="clickable-row" (click)="onRowClick(row)" [class.site-first-row]="row.isFirstInSite"
              [class.row-meter-flagged]="row.meter.meterStatus === 'Y'"
              [class.row-dic-flagged]="row.meter.dicStatus === 'Y'">
              <ng-container *ngFor="let h of allTableHeaders">
                <ng-container *ngIf="h._rowspan">
                  <td *ngIf="row.isFirstInSite" [attr.rowspan]="row.siteRowspan" class="valign-top">
                    <ng-container *ngIf="h.key === 'site_code'">
                      <span class="site-badge">{{ row.site.siteCode }}</span>
                    </ng-container>
                    <ng-container *ngIf="h.key === 'site_name'">
                      <div class="site-name">{{ row.site.name }}</div>
                      <div class="site-sup">{{ row.site.supervisorName }}</div>
                      <div class="site-contact" *ngIf="row.site.supervisorContact">{{ row.site.supervisorContact }}
                      </div>
                      <div class="sync-pill-site sync-ok" *ngIf="row.siteSyncStatus === 'ok'">
                        <span class="spill-dot spill-green"></span> All synced
                      </div>
                      <div class="sync-pill-site sync-lag" *ngIf="row.siteSyncStatus === 'lagging'">
                        <span class="spill-dot spill-amber"></span> {{ row.siteLaggingCount }} flagged
                      </div>
                    </ng-container>
                  </td>
                </ng-container>

                <td *ngIf="!h._rowspan">
                  <ng-container [ngSwitch]="getCellTemplate(h.key)">
                    <span *ngSwitchCase="'balance'">
                      <span [ngClass]="getBalanceClass(row.meter.balanceAmount)">
                        {{ row.meter.balanceAmount | currency:'INR':'symbol':'1.2-2' }}
                      </span>
                    </span>
                    <span *ngSwitchCase="'state'" class="a-status-chip"
                      [ngClass]="{ 'a-status-success': row.meter.state === 'Restored', 'a-status-danger': row.meter.state === 'Cut' }">
                      {{ row.meter.state }}
                    </span>
                    <span *ngSwitchCase="'dg_on'" class="a-status-chip" [ngClass]="{ 
                        'a-status-success': row.meter._raw['dg_on'] === 'ON', 
                        'a-status-danger': row.meter._raw['dg_on'] === 'OFF' 
                      }">
                      {{ row.meter._raw['dg_on'] }}
                    </span>
                    <span *ngSwitchCase="'meter_reading'" class="a-meter-stat-chip"
                      [ngClass]="{ 'a-meter-stat-success': row.meter.meterStatus === 'N', 'a-meter-stat-danger': row.meter.meterStatus === 'Y' }">
                      {{ row.meter.readingReceived }}
                    </span>
                    <span *ngSwitchCase="'dic_reading'" class="a-dic-stat-chip"
                      [ngClass]="{ 'a-dic-stat-success': row.meter.dicStatus === 'N', 'a-dic-stat-danger': row.meter.dicStatus === 'Y' }">
                      {{ row.meter.dicReadingReceived }}
                    </span>
                    <span *ngSwitchDefault>{{ getCellValue(row, h.key) }}</span>
                  </ng-container>
                </td>
              </ng-container>
            </tr>

            <!-- Site divider row -->
            <tr class="site-divider" *ngIf="row.isFirstInSite && row.siteRowspan === 1 ||
                   !row.isFirstInSite &&
                   (i === paginatedRows.length - 1 ||
                    paginatedRows[i + 1]?.site?.srNo !== row.site.srNo)">
              <td [attr.colspan]="allTableHeaders.length"></td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <!-- ── PAGINATION BAR ── -->
      <div class="pagination-bar" *ngIf="filteredRows.length > 0">

        <!-- Left: row count + page size selector -->
        <div class="pagination-meta">
          <span class="row-count-label">
            {{ (currentPage - 1) * pageSize + 1 }}-{{ getRangeEnd() }}
            of {{ filteredRows.length }} meter{{ filteredRows.length !== 1 ? 's' : '' }}
          </span>
          <span class="page-size-label">Rows per page</span>
          <div class="page-size-group">
            <select class="ps-select" style="padding: 2px 5px; border-radius: 4px; border: 1px solid #ced4da;"
              [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
              <option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }}</option>
            </select>
          </div>
        </div>

        <!-- Right: page navigation -->
        <div class="pagination-nav">
          <button class="pg-btn pg-arrow" [disabled]="currentPage === 1" (click)="goToPage(1)" title="First Page">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="15 18 9 12 15 6" />
              <line x1="5" y1="18" x2="5" y2="6" />
            </svg>
          </button>
          <button class="pg-btn pg-arrow" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>

          <ng-container *ngFor="let p of pageNumbers">
            <span class="pg-ellipsis" *ngIf="p === -1">…</span>
            <button class="pg-btn" *ngIf="p !== -1" [class.active]="p === currentPage" (click)="goToPage(p)">{{ p
              }}</button>
          </ng-container>

          <button class="pg-btn pg-arrow" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
          <button class="pg-btn pg-arrow" [disabled]="currentPage === totalPages" (click)="goToPage(totalPages)"
            title="Last Page">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="9 18 15 12 9 6" />
              <line x1="19" y1="18" x2="19" y2="6" />
            </svg>
          </button>
        </div>

      </div>

      <!-- Row count -->
    </div>
    <div class="row-count" *ngIf="filteredRows.length > 0">
      Showing {{ filteredRows.length }} meter{{ filteredRows.length !== 1 ? 's' : '' }}
      <span *ngIf="activeFilter !== 'all'"> · filtered by <strong>{{ activeFilter }}</strong></span>
    </div>


  </div>
</div>